import { render, staticRenderFns } from "./collapsible-block--atomized.vue?vue&type=template&id=c7fac290"
import script from "./collapsible-block--atomized.vue?vue&type=script&lang=js"
export * from "./collapsible-block--atomized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports